import { CardOrientation } from '@space-core/components/customCard/base/enum'
import { ImageOrientation } from '@space-core/components/customImage/enum'
import { GridOrientation } from '@space-core/components/grid/enum'

import { MAX_HORIZONTAL_CARDS, MAX_VERTICAL_CARDS, MAX_ITEMS_CAROUSEL } from './constants'

class GridUtils {
  static cardOrientationGridHorizontal(value: number) {
    const orientationGridHorizontal =
      value > MAX_HORIZONTAL_CARDS ? CardOrientation.VERTICAL : CardOrientation.HORIZONTAL

    return orientationGridHorizontal
  }

  static cardOrientationGridVertical(value: number) {
    const orientationGridHorizontal =
      value > MAX_VERTICAL_CARDS ? CardOrientation.VERTICAL : CardOrientation.HORIZONTAL

    return orientationGridHorizontal
  }

  static cardOrientation(orientation: string, itens: number) {
    const card =
      orientation === ImageOrientation.VERTICAL.toUpperCase()
        ? this.cardOrientationGridHorizontal(itens)
        : this.cardOrientationGridVertical(itens)

    return card
  }

  static gridOrientation(orientation: string) {
    const grid =
      orientation === ImageOrientation.VERTICAL.toUpperCase()
        ? GridOrientation.VERTICAL
        : GridOrientation.HORIZONTAL

    return grid
  }

  static containerOrientation(orientation: string) {
    const container =
      orientation === ImageOrientation.VERTICAL.toUpperCase()
        ? CardOrientation.VERTICAL
        : CardOrientation.HORIZONTAL

    return container
  }

  static imageOrientation(orientation: string) {
    const image =
      orientation === ImageOrientation.VERTICAL.toUpperCase()
        ? ImageOrientation.VERTICAL
        : ImageOrientation.HORIZONTAL

    return image
  }

  static isCarouselHorizontal(value: number) {
    const carouselHorizontal = value <= MAX_ITEMS_CAROUSEL && value > 1 ? true : false

    return carouselHorizontal
  }

  static isCarouselVertical(value: number) {
    const carouselVertical = value <= MAX_ITEMS_CAROUSEL ? true : false

    return carouselVertical
  }

  static isCarousel(orientation: string, value: number) {
    const carousel =
      orientation === ImageOrientation.HORIZONTAL.toUpperCase()
        ? this.isCarouselHorizontal(value)
        : this.isCarouselVertical(value)

    return carousel
  }
}

export default GridUtils
